import { render } from "./ISubscriptionSkeleton.vue?vue&type=template&id=5d34b9c7&scoped=true"
const script = {}

import "./ISubscriptionSkeleton.vue?vue&type=style&index=0&id=5d34b9c7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d34b9c7"]])

export default __exports__